import StyledLink from '../StyledLink'
import {
  ADD,
  ENVIRONMENTS
} from '../routes'
import type { Props } from '../types'

const LinkToAddSpaceEnvironment = ({
  children,
  isHyperlink
}: Props) =>
  <StyledLink
    isHyperlink={isHyperlink}
    to={'/' + ENVIRONMENTS + '/' + ADD}
  >
    {children}
  </StyledLink>

export default LinkToAddSpaceEnvironment
